import { getStoreId } from "$/hooks/use-store-information"
import { fortnoxQueries } from "$/lib/queries/fortnox-queries"
import storeQueries from "$/lib/queries/store-queries"
import { FortnoxConnectionResult } from "@repo/common"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

const searchSchema = z.object({
  // Set by the API when Fortnox redirects back after the OAuth approval.
  fortnox: z.nativeEnum(FortnoxConnectionResult).optional().catch(undefined),
})

export const Route = createFileRoute("/(app)/_auth/settings/kassakoppling")({
  validateSearch: searchSchema,
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(storeQueries.detail(storeId))
      queryClient.prefetchQuery(fortnoxQueries.status(storeId))
    }
    return {
      crumbs: "alfred.settings.nav.posIntegration.label",
    }
  },
})
